










































import {Component, Prop} from "vue-property-decorator";
import User from "../../common/User.vue";
import Speaker from "../../program/components/Speaker.vue";
import UsersList from "../../common/users-list/UsersList.vue"
import {ParticipantStatuses} from "../../../api/enums/Meetings/ParticipantStatuses";
import{Invite as InviteModel} from "../../../api/models/meetings/Invite";
import { TimeTooltipDirective } from '../../directives/Tooltip';
import InviteTypes from "../enums/InviteTypes";
import {UserProfile} from "@api/models/UserProfile";
import { ParticipantListMixin, ParticipantListInterface } from "../../../mixins/ParticipantList";
import {EventBus} from '@common/EventBus';
import MessageIcon from '../../../assets/svg/message.svg'
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

@Component({
    components: { User, Speaker, UsersList, MessageIcon },
    directives: { TimeTooltipDirective }
})
export default class Invite extends ParticipantListMixin implements ParticipantListInterface {
    @Prop({required: true}) invite: InviteModel;
    @Prop({required: true}) backend: string;
    @Prop({required: true}) userId: number;
    @Prop({required: true}) type: string;
    @Prop({default: 'en'}) lang: string;
    @Prop({default: false}) isOnBottom: boolean;

    showPopup = false;
    hoveringSpeaker: UserProfile | null = null;
    participantsContainer = this.invite;
    participantsField = 'participants';
    excludeParticipants = [this.userId];
    speakersLimit = 2;
    linkCopied = false;

    mounted() {
        if (!this.isReceived) {
            this.calcWidth();
            window.addEventListener('resize', this.calcWidth);
        }
    }

    activated() {
       this.calcWidth();
    }

    get owner() {
        return this.invite.participants && this.invite.participants.find(item => item.userId == this.invite.ownerId);
    }

    get currentUser() {
        return this.invite.participants && this.invite.participants.find(item => item.userId == this.userId);
    }

    get invitedUser() {
        if(this.isReceived) {
            return this.owner;
        }
        return this.invite.participants && this.invite.participants.find(item => item.userId == this.invite.userId);
    }

    get invitedUsers() {
        return this.invite.participants.filter(participant => participant.userId !== this.userId);
    }

    get statusClass() {
        return 'is-' + this.status?.toLowerCase();
    }

    get status() {
        if (this.isReceived) {
            return this.currentUserStatus;
        }
        if (this.invite.participants.filter(participant => participant.userId !== this.userId)
                .every(participant => participant?.status?.toLowerCase() === ParticipantStatuses.declined.toString())) {
            return ParticipantStatuses.declined.toString();
        }
        if (this.invite.participants.filter(participant => participant.userId !== this.userId)
                .some(participant => participant?.status?.toLowerCase() === ParticipantStatuses.accepted.toString())) {
            return ParticipantStatuses.accepted.toString();
        }
        return ParticipantStatuses.pending.toString();
    }

    get currentUserStatus() {
        return this.currentUser?.status?.toLowerCase();
    }

    get from() {
        return this.invite.beginAt?.toFormat('HH:mm');
    }

    get to() {
        return this.invite.endAt?.toFormat('HH:mm');
    }

    get tooltipProps() {
        return {
            start: this.invite.beginAt,
            end: this.invite.endAt,
            lang: this.lang,
            offset: this.$store.state.timeZoneOffset,
            offsetNames: this.$store.state.timeZoneNames
        }
    }

    get showAccept() {
        return this.currentUserStatus == ParticipantStatuses.declined.toString() || this.currentUserStatus == ParticipantStatuses.pending.toString()
    }

    get showDecline() {
        return this.currentUserStatus == ParticipantStatuses.pending.toString()
    }

    get showCopy() {
        return this.currentUserStatus == ParticipantStatuses.accepted.toString()
    }

    get isReceived() {
        return this.type == InviteTypes.received;
    }

    join(event: Event) {
        event.stopPropagation();
        this.$router.push({
            name: "ViewMeeting",
            params: {
                backend: this.$route.params.backend,
                eventId: this.$route.params.eventId,
                id: this.invite.meetingId || ''
            }
        })
    }

    accept(event: Event) {
        event.stopPropagation();
        this.changeStatus(ParticipantStatuses.accepted);
    }

    decline(event: Event) {
        event.stopPropagation();
        this.changeStatus(ParticipantStatuses.declined);
    }

    /**
     * copy meeting link to clipboard
     */
    copyLink(event: Event) {
        event.stopPropagation();

        const { href } = this.$router.resolve({
            name: RouteNamesEnum.viewMeeting,
            params: {
                backend: this.backend,
                eventId: this.$route.params.eventId,
                id: this.invite.meetingId
            }
        })

        navigator.clipboard.writeText(`${location.origin}${href}`);

        this.linkCopied = true;

        setTimeout(() => {
            this.linkCopied = false;
        }, 5000);
    }

    anotherTime(event: Event) {
        event.stopPropagation();
        EventBus.$emit('messageTo', this.invite.ownerId);
    }

    changeStatus(status: ParticipantStatuses) {
        this.$emit('changeStatus', {
            id: this.invite.meetingId,
            status: status,
            participantId: this.currentUser?.id
        })
    }

    calcWidth() {
        this.$nextTick(() => {
            if (this.$refs['speakers']) {
                const limit = Math.floor((this.$refs['speakers'] as HTMLElement).clientWidth / 38);
                if ((this.allSpeakers.length || 0) > limit) {
                    this.speakersLimit = limit - 1;
                } else {
                    this.speakersLimit = this.allSpeakers.length || 0;
                }
            }
        });
    }

    destroyed() {
        window.removeEventListener('resize', this.calcWidth);
    }
}
